class L.Control.MFDraw extends L.Control

    options:
        position: 'topleft'
        toolbars: [
            { # Box/Group
                rows: [
                    [ # Row
                        # Each object here defines a button / column in the row

                        # data name, symbol, toggle
                        { name: 'draw-poly-add', html: '<i class="drawicon-poly-green"></i>', toggle: true },
                        { name: 'draw-poly-sub', html: '<i class="drawicon-poly-red"></i>', toggle: true }
                    ],
                    [
                        { name: 'draw-rect-add', html: '<i class="drawicon-rect-green"></i>', toggle: true },
                        { name: 'draw-rect-sub', html: '<i class="drawicon-rect-red"></i>', toggle: true },
                    ],
                    [
                        { name: 'draw-circle-add', html: '<i class="drawicon-circle-green"></i>', toggle: true },
                        { name: 'draw-circle-sub', html: '<i class="drawicon-circle-red"></i>', toggle: true },
                    ]
                ]
            },
            {
                style: {
                    width: '29px'
                }
                rows: [
                    [
                        { name: 'draw-select', html: '<i class="fa fa-hand-o-up"></i>', toggle: true },
                    ],
                    [
                        { name: 'draw-delete', html: '<i class="fa fa-trash-alt"></i>', toggle: true }
                    ],
                    [
                        { name: 'draw-undo', html: '<i class="fa fa-reply"></i>', toggle: false }
                    ]
                ]
            }

        ]


    onAdd: (map) ->
        @callbacks  = {}
        @buttons    = {}

        @outerContainer = L.DomUtil.create 'div'
        self = this
        @_map = map

        # add each toolbar into the container
        for tb in @options.toolbars
            drawControl = 'leaflet-control-mfdraw'
            container = L.DomUtil.create 'div', "#{drawControl} leaflet-bar", @outerContainer

            if tb.style?
                $(container).css tb.style

            # iterate over the rows for the toolbar, adding them...
            for v in tb.rows
                row = @_addRow container

                # add each button in the row
                for btn in v
                    txt         = btn.html ? btn.name
                    dataName    = btn.name

                    @callbacks[dataName] = []

                    nbtn = L.DomUtil.create 'a', "clickable #{dataName} pull-left", row
                    nbtn.innerHTML = "#{txt}"

                    $(nbtn).data 'drawName', dataName

                    # track the button we created as associated to the drawName it has
                    @buttons[dataName] = $(nbtn)

                    # Hide the tooltip when hovering over the button
                    $(nbtn).on 'mouseenter', (e) ->
                        $('.leaflet-draw-tooltip').hide()

                    $(nbtn).on 'mouseleave', (e) ->
                        $('.leaflet-draw-tooltip').show()

                    # Handle click events. If the button is disabled, don't fire click events
                    $(nbtn).on 'click', (e) ->
                        e.preventDefault()
                        #L.DomEvent.preventDefault(e.originalEvent)
                        if $(e.currentTarget).hasClass 'leaflet-mfdraw-disabled'
                            return

                        self.handleClick($(e.currentTarget).data('drawName'), e)
                        return false

                    # If the button is a toggle, add the base toggle handler
                    if btn.toggle? and btn.toggle
                        @addCallback dataName, (e, drawname) ->
                            self.toggleButton drawname
                    else
                        @addCallback dataName, (e, drawname) ->
                            self.toggleButton drawname, false



        return @outerContainer


    toggleButton: (btn, select = true) =>
        @deselectAllButtons()
        if select
            @selectBtn btn

    getButton: (btn) ->
        return @buttons[btn]


    selectBtn: (btn) ->
        button = @buttons[btn]
        button.addClass 'leaflet-mfdraw-active'


    deselectBtn: (btn) ->
        button = @buttons[btn]
        button.removeClass 'leaflet-mfdraw-active'


    deselectAllButtons: () ->
        self = this
        for k of @buttons
            @deselectBtn k


    disableBtn: (btn) ->
        btns = @_parseButtonSelector btn
        for i in btns
            button = @buttons[i]
            @deselectBtn i
            button.addClass 'leaflet-mfdraw-disabled'


    enableBtn: (btn) ->
        btns = @_parseButtonSelector btn
        for i in btns
            button = @buttons[i]
            button.removeClass 'leaflet-mfdraw-disabled'


    # Enables fancy selectors like "*" (all buttons) and
    # "draw-poly-add,draw-rect-add" (both 'draw-poly-add' and 'draw-rect-add' buttons)
    _parseButtonSelector: (sel) ->
        result = []
        if sel is '*'
            for k, v of @buttons
                result.push k
        else
            multi = sel.split(',')

            for i in multi
                result.push i

        return result


    handleClick: (name, e) =>
        for i in @callbacks[name]
            i(e, name, @outerContainer)



    addCallback: (dataName, cb) ->
        # add a blanket callback (useful for setting up toggles and other behavior)
        #
        btn  = @_parseButtonSelector dataName

        for i in btn
            @callbacks[i].push cb


        return cb



    removeCallback: (dataName, cb) ->
        ind = @callbacks[dataName].indexOf(cb)
        if ind isnt -1
            @callbacks[dataName].splice ind, 1



    _addRow: (container) ->
        row = L.DomUtil.create 'div', 'leaflet-mfdraw-row', container

        return row
